import { Modal } from "components/molecules";
import { Button, Typography } from "components/atoms";
import classNames from "classnames";
import { CloseIcon } from "components/atoms/Icon";
import "./error-mobile-modal.scss";

interface IProps {
  isOpen: boolean;
  handleOnclose: any;
  theme: "light" | "dark";
  openBottom?: boolean;
  message: any;
}

export const ErrorMobileModal = ({
  isOpen,
  handleOnclose,
  theme,
  openBottom,
  message,
}: IProps) => {
  return (
    <Modal
      isOpen={isOpen}
      onClose={handleOnclose}
      theme={theme}
      style="error-mobile-modal-custom-style"
      openBottom={openBottom}
    >
      <>
        <div
          className={classNames({
            "error-mobile-modal-header-wrapper": true,
            "error-header": true,
          })}
        >
          <Typography
            variant="h8Med"
            label="Error"
            styles="error-mobile-modal-header-text"
          />
          <div
            className="error-mobile-modal-header-close-icon"
            onClick={handleOnclose}
          >
            <CloseIcon theme={theme} />
          </div>
        </div>
        <div
          className={classNames({
            "error-mobile-modal-body-wrapper": true,
            "error-body": true,
          })}
        >
          <Typography
            variant="h9Book"
            label={message}
            styles="error-mobile-modal-info-text"
          />
          <div
            className={classNames({
              "error-mobile-modal-button-wrapper": true,
            })}
          >
            <Button
              icon={false}
              type="score"
              label="Okay"
              onClick={handleOnclose}
            />
          </div>
        </div>
      </>
    </Modal>
  );
};
